/* eslint-disable prettier/prettier */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Usuarios from "layouts/usuarios";
import Roles from "layouts/roles";
import Solicitudes from "layouts/solicitudes";
// @mui icons
import Icon from "@mui/material/Icon";
import Catalogos from "layouts/catalogos";
import Expedientes from "layouts/expedientes";
import IntentosDeSolicitud from "layouts/intentossolicitud";
import PreOperatorio from "layouts/mapaProcesos/preOperatorio";
import Operatorio from "layouts/mapaProcesos/operatorio";
import PostOperatorio from "layouts/mapaProcesos/postOperatorio";
import Tav from "layouts/tav";
//type, name, icon, title, noCollapse, key, href, route
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    idPermiso: 1,
  },
  {
    type: "collapse",
    name: "Solicitudes",
    key: "solicitud",
    icon: <Icon fontSize="medium">description</Icon>,
    route: "/solicitud",
    component: <Solicitudes />,
    idPermiso: 3,
  },
  {
    type: "collapse",
    name: "Expedientes",
    key: "expedientes",
    icon: <Icon fontSize="medium">topic</Icon>,
    route: "/expedientes",
    component: <Expedientes />,
    idPermiso: 4,
  },
  {
    type: "collapse",
    name: "Intentos de solicitud",
    key: "intentos",
    icon: <Icon fontSize="medium">checklist</Icon>,
    route: "/intentos",
    component: <IntentosDeSolicitud />,
    idPermiso: 53,
  },
  {
    type: "collapse",
    name: "TAV",
    key: "tav",
    icon: <Icon fontSize="medium">hearing</Icon>,
    route: "/tav",
    component: <Tav />,
    idPermiso: 51,
  },
  {
    type: "title",
    key: "titleMapa",
    title: "Mapa de procesos",
    idPermiso: 2,
  },
  {
    type: "collapse",
    name: "Pre-Operatorio",
    key: "preoperatorio",
    icon: <Icon fontSize="medium">science</Icon>,
    route: "/preOperatorio",
    component: <PreOperatorio />,
    idPermiso: 2,
  },
  {
    type: "collapse",
    name: "Operatorio",
    key: "operatorio",
    icon: <Icon fontSize="medium">medical_services</Icon>,
    route: "/operatorio",
    component: <Operatorio />,
    idPermiso: 2,
  },
  {
    type: "collapse",
    name: "Post-Operatorio",
    key: "postoperatorio",
    icon: <Icon fontSize="medium">medication_liquid</Icon>,
    route: "/postOperatorio",
    component: <PostOperatorio />,
    idPermiso: 2,
  },
  {
    type: "title",
    key: "titleadmin",
    title: "Administración",
    idPermiso: 6,
  },
  {
    type: "collapse",
    name: "Usuarios",
    key: "usuarios",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/usuarios",
    component: <Usuarios />,
    idPermiso: 6,
  },
  {
    type: "collapse",
    name: "Roles",
    key: "roles",
    icon: <Icon fontSize="small">badge</Icon>,
    route: "/roles",
    component: <Roles />,
    idPermiso: 6,
  },
  {
    type: "collapse",
    name: "Catalogos",
    key: "catalogos",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/catalogos",
    component: <Catalogos />,
    idPermiso: 6,
  },
];

export default routes;
